import { render } from "./StatusDialog.vue?vue&type=template&id=2b108564"
import script from "./StatusDialog.vue?vue&type=script&lang=js"
export * from "./StatusDialog.vue?vue&type=script&lang=js"

import "./StatusDialog.vue?vue&type=style&index=0&id=2b108564&lang=css"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__